export const getSlackChurnString = (cancellationInfo, fields) => {
  const {
    accountCreated,
    accountId,
    billingEmail,
    expectedChurnDate,
    companyName,
    requestDate,
    planName,
    subscriptionStart,
    userEmail,
  } = cancellationInfo;
  const {
    competitorInfo,
    leaveReason,
    qualitativeFeedback,
    replacementInfo,
    useAgainInfo,
  } = fields;

  const slackMessage = `*Churn Alert*\nAccount ID: ${accountId}\nCompany Name: ${companyName}\nBilling Contact: ${billingEmail}\nRequestor Contact: ${userEmail}\nPlan Name:${planName}\nChurn Request Date: ${requestDate}\nAppcues Account Created Date: ${accountCreated}\nSubscription Start Date: ${subscriptionStart}\nExpected Churn Date: ${expectedChurnDate}\n\n*Churn Feedback Responses*\nChurn Reason: ${leaveReason}\nChurn Reason Detail: ${qualitativeFeedback}\nAppcues Replacement: ${replacementInfo}\nCompetitor:${competitorInfo}\nWould come back to Appcues?: ${useAgainInfo}`;

  return slackMessage;
};
